import React, {Component} from 'react';
import $ from 'jquery';
import 'jquery-validation';
import {getPeopleBySkills} from '../../util/APIUtils';
import {Field, reduxForm} from 'redux-form';
import {Provider} from "react-redux";
import Store from '../../helpers/Store';
import {inputField} from '../../helpers/Error';
import moment from 'moment';
import CreatableSelect from "react-select/lib/Creatable";
import Select from 'react-select';

import {
       JOB_PRIORITY_LOW,JOB_PRIORITY_MEDIUM,JOB_PRIORITY_HIGH,
       JOB_STATUS_SCHEDULED,JOB_STATUS_UNSCHEDULED,JOB_STATUS_WORKING,JOB_STATUS_CLOSED
       } from '../../constants';
import './JobScheduleForm.css';
import 'datepair.js';
const validate = (values, props) => {
    const errors = {};
    return errors;
};
const options = [
  { value: 'THIS_EVENT', label: 'This event' },
  { value: 'THIS_AND_FOLLOWING_EVENT', label: 'This and following event' },
  { value: 'ALL_EVENTS', label: 'All Events' }
];

class modelForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            skills: [],
            people: []
        };
    }
    componentDidMount() {
        var $this = this;
    }
    render() {
        return (
            <form name="editjobscheduleform" id="editjobscheduleform">
                   
                    <input type="hidden" id="editid"/>
                     <input type="hidden" id="workorderid"/>
                     <input type="hidden" id="recurrnceId"/>
                      <input type="hidden" id="peopleId"/>
                    <div className="row">
                        <div className="col-lg-12">
                            <div id="editbasicExample" className="form-group" >
                                <div >
                                    <label className="control-label">Start Time</label>
                                    <div>
                                        <input type="text" id="editfromdate" name="editfromdate" placeholder="MM/DD/YYYY" className="form-control date start" style={{width: '53%'}}  /> &nbsp;&nbsp;&nbsp;
                                        <input type="text" id="editfromtime" name="editfromtime" placeholder="00:00 AM/PM" className="form-control time start" style={{width: '42%'}}   autoComplete="off" />
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div className="col-lg-12">
                             <label className="control-label">Recurring</label>
                            
                             <select className="form-control" name="recurringaction" id="recurringaction" >
                               
                                <option value="THIS_EVENT">This Events</option>
                                 <option value="THIS_AND_FOLLOWING_EVENT">This and following event</option>
                                 <option value="ALL_EVENTS">All Events</option>
                             </select>
                        </div>
                        
                    </div>
            </form>
        );
    }
}

const ModelForm = reduxForm({
    form: 'model_form',
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    updateUnregisteredFields: true,
    validate
})(modelForm);

class MultipleJob extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
      //  this.setState({loading: false});
    }

	componentDidMount() {
        let $this = this;
      
        $('#editfromdate').datepicker({
            todayBtn: "linked",
            keyboardNavigation: false,
            forceParse: false,
            autoclose: true

        });

     /*  $('#date-daily').datepicker({
            todayBtn: "linked",
            keyboardNavigation: false,
            forceParse: false,
            autoclose: true

        });*/

        /*$('#edittodate').datepicker({
            todayBtn: "linked",
            keyboardNavigation: false,
            forceParse: false,
            autoclose: true

        });*/

        $('#editbasicExample .time').timepicker({
            showDuration: true,
            template : false,
            showInputs : false,
            minuteStep : 5,
            timeFormat: 'g:i A'
        });

        $.validator.setDefaults({
            ignore: []
        });
                $("#editjobscheduleform").validate({
                    ignore: [],
			    	   		rules: {
			              //	  title:{required:true},
                            //  selectedSkill:{required:true},
                              editfromdate:{required:true},
                              editfromtime:{required:true},
                            //  edittodate:{required:true},
                             // edittotime:{required:true}
                            //  selectedPeoples:{required:true}
                            //  team:{required:true},
                           //   equipment:{required:true}
			    	   		},
				    	   	messages: {
				    	   	  editfromdate:"Please enter date and time",
                              editromtime:"Please enter date and time",
                            //  edittodate:"Please enter date and time",
                             // edittotime:"Please enter date and time"
				    	   	},     
                    groups:{date:"fromdate fromtime todate totime"},
                    errorPlacement: function(error, element) {
                       if (element.attr("name") == "editfromdate" || element.attr("name") == "editfromtime" || element.attr("name") == "edittodate" || element.attr("name") == "edittotime") 
                        error.insertAfter("#editbasicExample");
                       else 
                          error.insertAfter(element);
                      }
		    	 });         

	}
    componentWillMount(){
        
    }
    render(){
    return (
        
           <div className="modal fade none-border bs-example-modal-md" id="multiple-event" data-keyboard="false" data-backdrop="static">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                           
<div className="card card-outline-info">
                        


                            <div className="card-header">
                                <h4 className="m-b-0 text-white">Edit Schedule</h4>
                            </div>


                               {this.props.states.showMessage
                                ? <div className="alert alert-danger" style={{width:'100%'}}> <i className="fa fa-warning"></i> {this.props.states.messageText}
                                            <button type="button" className="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">×</span> </button>
                                </div>
                                : ''
                              }
                            
  </div>
                            <div className="modal-body">

                                <Provider store={Store}>
                                    <ModelForm states={this.props.fields} initialValues={this.state}/>
                                </Provider>
                            </div>
                            <div className="modal-footer">
                               <button type="button" className="btn btn-danger waves-effect waves-light save-category btn-rounded" id="deleteevent">Delete Job</button>
                             
                                <button type="button" className="btn btn-primary waves-effect waves-light save-category btn-rounded" id="editsaveevent">Save</button>
                                <button type="button" className="btn btn-white waves-effect btn-rounded" id="editcloseevent">Cancel</button>
                               
                            </div>
                        </div>
                    </div>
                </div>
            

          );
  } 
}
export default MultipleJob;